(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner-section"] && !Shopify.designMode) return;
  try {
    
function initHomeBanner(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) return;

  const track = section.querySelector('.home-banner-track');
  let slides = Array.from(track.children);
  const dotsContainer = section.querySelector('.home-banner-dots');
  const prevBtn = section.querySelector('.home-banner-arrow--prev');
  const nextBtn = section.querySelector('.home-banner-arrow--next');

  const slideCount = slides.length;

  // Only enable slider (dots + arrows + autoplay) when 2+ slides
  if (slideCount <= 1) {
    // Just ensure track is at start without clones
    track.style.transform = 'translateX(0)';
    return;
  }

  // Mark section so CSS shows arrows
  section.classList.add('has-multiple-slides');

  // --- Infinite Scroll Setup ---
  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[slideCount - 1].cloneNode(true);
  track.appendChild(firstClone);
  track.prepend(lastClone);

  let currentIndex = 1; // Start on the first "real" slide
  let autoPlayInterval;
  let isDragging = false;
  let startPos = 0;
  let currentTranslate = 0;

  function setInitialPosition() {
    const slideWidth = slides[0].offsetWidth;
    currentTranslate = -slideWidth;
    track.style.transition = 'none';
    track.style.transform = `translateX(${currentTranslate}px)`;
  }
  setInitialPosition();

  // Re-select slides to include clones
  slides = Array.from(track.children);

  // --- Dots Logic ---
  for (let i = 0; i < slideCount; i++) {
    const dot = document.createElement('div');
    dot.classList.add('home-banner-dot');
    dot.addEventListener('click', () => {
      currentIndex = i + 1;
      goToSlide();
      resetAutoPlay();
    });
    dotsContainer.appendChild(dot);
  }
  const dots = dotsContainer.querySelectorAll('.home-banner-dot');

  function updateDots() {
    const realIndex = (currentIndex - 1 + slideCount) % slideCount;
    dots.forEach(d => d.classList.remove('active'));
    dots[realIndex].classList.add('active');
  }

  function goToSlide() {
    track.style.transition = 'transform 0.6s ease';
    const slideWidth = slides[0].offsetWidth;
    currentTranslate = -currentIndex * slideWidth;
    track.style.transform = `translateX(${currentTranslate}px)`;
    updateDots();
  }

  function nextSlide() {
    currentIndex++;
    goToSlide();
  }

  function prevSlide() {
    currentIndex--;
    goToSlide();
  }

  // --- Arrow click events ---
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      stopAutoPlay();
      nextSlide();
      resetAutoPlay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      stopAutoPlay();
      prevSlide();
      resetAutoPlay();
    });
  }

  // --- Transition end (loop handling) ---
  track.addEventListener('transitionend', () => {
    if (currentIndex === 0) { // first clone (of last slide)
      track.style.transition = 'none';
      currentIndex = slideCount;
      const slideWidth = slides[0].offsetWidth;
      currentTranslate = -currentIndex * slideWidth;
      track.style.transform = `translateX(${currentTranslate}px)`;
    }
    if (currentIndex === slideCount + 1) { // last clone (of first slide)
      track.style.transition = 'none';
      currentIndex = 1;
      const slideWidth = slides[0].offsetWidth;
      currentTranslate = -currentIndex * slideWidth;
      track.style.transform = `translateX(${currentTranslate}px)`;
    }
  });

  // --- Drag/Touch Logic ---
  track.addEventListener('mousedown', dragStart);
  track.addEventListener('touchstart', dragStart, { passive: true });
  track.addEventListener('mouseup', dragEnd);
  track.addEventListener('touchend', dragEnd);
  track.addEventListener('mouseleave', dragEnd);
  track.addEventListener('mousemove', dragging);
  track.addEventListener('touchmove', dragging, { passive: false });

  function dragStart(e) {
    stopAutoPlay();
    isDragging = true;
    startPos = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    track.style.transition = 'none';
    track.classList.add('dragging');
  }

  function dragging(e) {
    if (!isDragging) return;
    const currentPosition = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    const diff = currentPosition - startPos;
    track.style.transform = `translateX(${currentTranslate + diff}px)`;
  }

  function dragEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('dragging');
    const endPos = e.type.includes('mouse') ? e.pageX : e.changedTouches[0].clientX;
    const movedBy = endPos - startPos;

    if (movedBy < -50) currentIndex++;
    if (movedBy > 50) currentIndex--;

    goToSlide();
    resetAutoPlay();
  }

  // --- Autoplay ---
  function startAutoPlay() {
    autoPlayInterval = setInterval(nextSlide, 4000);
  }
  function stopAutoPlay() {
    clearInterval(autoPlayInterval);
  }
  function resetAutoPlay() {
    stopAutoPlay();
    startAutoPlay();
  }

  // Initialize
  updateDots();
  startAutoPlay();

  // Recalculate on resize
  window.addEventListener('resize', () => {
    setInitialPosition();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home-banner-section').forEach(wrapper => {
    initHomeBanner(wrapper.id);
  });
});

document.addEventListener('shopify:section:load', e => {
  const sectionElement = document.getElementById(`home-banner-${e.detail.sectionId}`);
  if (sectionElement) {
    initHomeBanner(sectionElement.id);
  }
});

  } catch(e) { console.error(e); }
})();
})();
